var c = [
  15, 2, 40, 40, 480, 5, 3, 10, 7, 2, 379, 1, 9, 2, 59, 2, 697, 5, 3, 9, 10, 10,
  7, 5, 2, 15, 3, 2, 1, 4, 8, 3, 1, 2, 3, 15, 1, 1, 3, 2, 1, 3, 9, 10, 5, 47, 1,
  15, 1, 15, 15, 6, 1, 2, 2, 10, 1, 2, 2, 2, 2, 2, 2, 10, 12, 75, 1, 5, 5, 10,
  10, 15, 3, 15, 2, 1, 10, 2, 2, 1, 2, 1, 3, 1, 300, 1, 2, 60, 3, 5, 1, 2, 1, 2,
  4, 15, 1, 2, 1, 10, 2, 2, 5, 2, 5, 10, 19, 1, 9, 2, 3498, 70, 300, 10, 8850,
  42, 398, 60, 4759, 169, 25, 10, 390, 40, 5, 5, 40, 9, 3149, 45, 9, 8, 50, 9,
  15, 5, 3, 20, 5, 14, 1, 3, 17, 2, 25, 30, 14, 43, 2, 1, 1, 10, 2, 100, 5, 10,
  99, 15, 10, 4, 2, 8, 2, 430, 5, 2, 10, 35, 3890, 350, 40, 11, 7, 5, 3, 49, 30,
  5300, 650, 65, 5, 2, 5, 3, 19, 30, 2999, 500, 19, 2, 1, 1, 1, 20, 19, 270,
  160, 10, 1, 1, 2, 1, 47, 65, 3989, 579, 79, 1, 1, 3, 2, 9, 9, 1700, 179, 19,
  1, 199, 5, 1, 99, 100, 5999, 950, 99, 13, 1, 1, 1, 10, 10, 1500, 115, 10, 1,
  1, 11, 198, 250, 69, 25, 450, 15, 10, 50, 59, 5500, 373, 1249, 900, 949, 490,
  14499, 598, 1099, 89, 198, 369, 50, 22, 90, 4500, 90, 565, 39, 11, 398, 135,
  230, 300, 4200, 999, 2490, 2699, 290, 300, 309, 69, 79, 150, 287, 148, 249,
  38, 6299, 12900, 60, 58, 259, 3150, 350, 3800, 4000, 4000, 999, 200, 200, 600,
  237, 199, 399, 265, 270, 7500, 3000, 3899, 3850, 4110, 30, 40, 40, 15000,
  28999, 50000, 19498, 2, 17, 10, 7, 4, 3, 2, 2, 3, 4, 1, 5, 15, 1, 3, 1, 40,
  50, 25, 40, 50, 30, 2, 15, 3, 2, 25, 20, 19, 36, 3, 10, 14, 20, 13, 5, 10, 28,
  25, 10, 15, 50, 55, 69, 89, 97, 55, 10, 85, 2, 10, 20, 20, 19, 30, 15, 16, 30,
  18, 15, 16, 18, 20, 19, 19, 15, 100, 100, 100, 110, 70, 95, 15, 19, 20, 15,
  925, 15, 20, 130, 58999, 9999, 500, 17500, 739, 588, 479, 199, 65, 75, 60,
  100, 200, 899, 193, 3999, 4599, 14000, 4750, 4800, 3500, 3799, 5300, 12699,
  1100777, 5, 1, 9, 1, 10, 1, 3, 2, 4, 1, 1, 2, 5, 17, 1, 2, 10, 3, 4, 9, 4, 10,
  15, 93, 1400, 24999, 27999, 15000, 8200, 17, 1, 2, 1, 2, 15, 2, 3, 2, 5, 10,
  239, 2, 1, 2, 1, 1, 1, 2, 1, 2, 2, 3, 1, 1, 4, 2, 30, 45, 3, 4, 10, 15, 25,
  40, 199, 2, 37, 3, 2, 2, 200, 1, 20, 20, 1, 1, 1, 2, 2300, 2222, 33, 3850,
  205, 175, 40, 290, 3, 250, 30, 14, 400, 25, 2, 2, 2, 2, 3, 3, 10, 2, 5, 20,
  443, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 25, 410, 2, 5, 40, 15, 24,
  30, 2, 4, 4, 2, 3, 20, 40, 2, 2, 2, 2, 5540, 5660, 300, 3737, 40, 50, 13999,
  7, 1, 1, 1, 1, 10, 1, 1, 1, 2, 10, 1, 2, 1, 1, 1, 1, 1, 1, 2, 2, 1, 1, 1, 1,
  1, 9, 1, 2, 10, 8, 3, 10, 1, 2, 1, 1, 1, 10, 3, 1, 1, 2, 1, 11, 420, 239,
  2888, 20, 15, 1, 1, 12, 10, 7, 10, 1, 3, 1, 1, 1, 9, 10, 1, 1, 1, 1, 225, 200,
  1850, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 11, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2,
  1, 1, 1, 10, 139, 1, 1, 1, 6, 100, 1, 1, 5, 6, 5, 5, 1, 1, 1, 1, 1, 5, 9, 1,
  1, 1, 1, 294, 300, 5, 1, 1, 1, 1, 5, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  1, 1, 1499, 1, 1, 1, 7, 4, 1, 4, 5, 4, 9, 7, 1, 1, 1, 1, 1, 5, 10, 1, 1, 1, 1,
  5, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 100,
  1000, 30, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 56, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  1, 1, 1, 1, 7, 10, 1, 1, 5, 6, 4, 7, 50, 1, 1, 1, 1, 1, 5, 5, 1, 1, 1, 1, 750,
  850, 80, 899, 100, 800, 1599, 4600, 4900, 14798, 13333, 16500, 2, 5, 5, 7, 10,
  5, 25, 20, 20, 149, 5, 10, 225, 500, 500, 125, 20, 15, 169, 999, 4000, 3999,
  499, 200, 49, 120, 40, 196, 39, 15, 30, 190, 10, 19, 5, 50, 35, 189, 5490,
  420, 469, 50, 50, 247, 589, 55, 200, 2350, 14200, 10000, 5, 90, 6400, 4899,
  200, 14, 100, 15, 9, 10, 59, 29, 10, 95, 100, 16900, 20999, 10800, 8380, 4500,
  0, 260, 2699, 10, 7, 400, 2498, 1, 2, 1, 1, 1, 2, 1, 2, 5, 9, 2, 7, 10, 5, 1,
  1, 1, 1, 1, 1, 1, 2, 2, 1, 10, 9, 10, 8, 1, 1, 2, 247, 43, 2795, 401, 339,
  205, 120, 51999, 200, 45, 42, 44, 2300, 220, 780, 2500, 7499, 230, 266666,
  65999, 11999, 39000, 2946, 79, 2899, 56, 750, 9600, 2299, 200, 2995, 199, 20,
  16999, 49, 270, 2280, 2300, 255, 49, 99, 350, 220, 15, 299, 36, 250, 15, 3150,
  48, 30, 449, 399, 19, 44, 59, 40, 6000, 2300, 48, 210, 2129, 219, 400, 260, 7,
  10, 80, 496, 470, 5111, 2250, 15500, 12999, 29999, 6999, 3450, 2000, 190, 23,
  3288, 18999, 4100, 275, 444, 400, 7999, 3500, 1399, 900, 1000, 550, 897, 430,
  1150, 899, 2450, 1799, 2269, 53000, 20000, 190, 400, 250, 300, 170, 250, 505,
  14777, 400, 320, 329, 359, 128, 270, 500, 5750, 1599, 2288, 100, 100, 600,
  320, 150, 99, 200, 999, 499, 105, 299, 279, 100, 1130, 777, 100, 90, 190, 179,
  850, 179, 10000, 17998, 38555, 1600000, 16999, 519019, 12000, 13000, 15000,
  27000, 33999, 26999, 25000, 239, 1000, 300, 90, 350, 79, 54, 4499, 60, 500,
  290, 280, 33000, 50, 410, 4250, 27299, 192, 449, 199, 150, 19, 49, 55, 400,
  50, 90, 15, 40, 50, 7, 20, 6, 14, 20, 30, 20, 20, 9, 30, 6, 125, 36, 6, 6, 9,
  50, 25, 15, 54, 21, 100, 19, 2498, 120, 299, 497, 190, 100, 3399, 449, 6000,
  400, 22500, 44, 299, 500, 369, 2500, 549, 2899, 2400, 4300, 400, 379, 32999,
  18999, 3450, 4499, 1200, 89, 120, 99, 60, 50, 100, 2499, 50, 100, 40, 100, 80,
  49, 10, 5, 20, 28, 60, 50, 12, 10, 25, 5, 15, 45, 5, 9, 5, 31, 35, 24, 40, 50,
  19, 15, 59, 260, 194, 45, 50, 129, 8200, 170, 188, 30, 20, 50, 8300, 220, 280,
  29, 150, 1500, 149, 1800, 200, 129, 190, 150, 50, 50, 35, 25, 49, 95, 250, 10,
  14, 38, 44, 20, 7, 10, 10, 3, 19, 20, 50, 10, 5, 20, 5, 6, 19, 5, 3, 5, 70,
  19, 15, 8, 10, 24, 7, 1890, 45, 1368, 1288, 148, 100, 35, 179, 120, 1900, 190,
  80, 329, 5, 43, 73, 20, 39, 50, 250, 12, 49, 50, 39, 24, 5, 5, 2, 3, 15, 20,
  19, 10, 20, 15, 3, 5, 10, 3, 2, 9, 1, 9, 10, 2, 19, 15, 5, 200, 300, 1000, 50,
  1950, 2080, 2450, 12, 250, 150, 12099, 1450, 59, 35, 40, 50, 100, 70, 400, 31,
  90, 35, 31, 50, 7, 5, 5, 10, 19, 19, 15, 10, 4, 11, 2, 5, 10, 5, 5, 3, 5, 8,
  9, 10, 15, 15, 1, 990, 1150, 100, 69, 52, 120, 55, 10, 199, 225, 49, 150, 498,
  699, 300, 1969, 1399, 29, 15, 39, 25, 15, 500, 249, 18, 30, 15, 15, 20, 2, 2,
  1, 2, 1, 25, 5, 8, 6000, 1, 5, 12, 10, 1, 2, 7, 1, 9, 9, 9, 15, 12, 1, 4500,
  11999, 26999, 32999, 23999, 450000, 9157, 475000, 39000, 50, 600, 90, 4669,
  40, 110, 39, 96, 99, 97, 100, 630, 200, 30, 60, 549, 49, 29, 7600, 80, 37999,
  3200, 39, 58, 79, 3600, 98, 34, 95, 500, 145, 400, 1, 1, 200, 149, 225, 490,
  300, 999, 99, 95, 99, 5100, 200, 397, 99, 39, 3499, 298, 2975, 248, 57000,
  24500, 19499, 7988, 40, 380, 139, 150, 170, 99, 200, 850, 500, 300, 100, 59,
  81, 2990, 139, 80, 14000, 319, 310, 219, 100, 100, 2800, 3777, 500, 300, 155,
  2999, 17999, 22222, 6799, 711, 2400, 479, 2599, 129, 50, 54, 15, 14, 60, 120,
  10, 35, 50, 10, 55, 2, 7, 2, 5, 30, 55, 29, 7, 4, 20, 4, 8, 25, 3, 3, 5, 1,
  10, 9, 10, 10, 2, 3, 36009, 609, 625, 150, 700, 366, 140, 50, 40, 45, 50, 25,
  135, 100, 99, 50, 59, 50, 35, 35, 10, 50, 25, 170, 48, 25, 19, 70, 2, 8, 20,
  2, 5, 5, 45, 90, 34, 15, 50, 75, 1, 10, 10, 790, 680, 19, 20, 90, 70, 5, 10,
  90, 5, 1, 1, 10, 10, 1, 1, 2, 79, 5, 1, 1, 5, 5, 10, 10, 1, 1, 97, 1, 1, 10,
  2, 1, 1, 3, 2, 2, 1, 1, 1, 1, 2199, 2500, 3000, 1899, 8500, 6599, 4900, 38000,
  19000, 19000, 38000, 27000, 11500, 23999, 58000, 400, 225, 2498, 3, 3000,
  1299, 850, 100, 11000, 2000, 3000, 0, 22000, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 150000,
];
module.exports.estimateValue = function (d) {
  if (c[d]) {
    return c[d];
  } else {
    return 0;
  }
};
module.exports.update = function (d) {
  c = d;
};
module.exports.change = function (d, f) {
  c[d] = f;
};
module.exports.get = function (d) {
  return c[d];
};
module.exports.dump = function () {
  return c;
};
